import { Typography } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import FullSandboxText from "./FullSandboxText";
import OneRosterSandboxText from "./OneRosterSandboxText";

const Title = styled(Typography)`
  font-size: 1rem;
  font-weight: 600;
`;

const LegalP = styled.p`
  &&& {
    font-size: 0.875rem;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1.43;
    letter-spacing: 0.01071em;
    margin-bottom: 10px;
  }
`;

const LegalPHeader = styled.p`
  font-size: 0.93rem;
  font-weight: 550;
`;

export enum SandboxTypes {
  OneRoster,
  Full,
}

const getSandboxText = (sbType: SandboxTypes) => {
  if (sbType === SandboxTypes.OneRoster) {
    return <OneRosterSandboxText />;
  } else {
    return <FullSandboxText />;
  }
};

const ndaUrl = "https://www.skyward.com/NewSkywardSite/media/PDFs/One-Way-NDA.pdf";

export function SandboxRequestText(sandboxType: SandboxTypes) {
  return (
    <>
      <Title>Access to Skyward Sandbox Options for 3rd Party Vendors</Title>
      <hr />
      <LegalPHeader>What you get</LegalPHeader>
      {getSandboxText(sandboxType)}
      <LegalPHeader>General Support</LegalPHeader>
      <LegalP>Support for the sandbox may be obtained by utilizing the Support Ticket functionality on this site.</LegalP>
      <LegalPHeader>Professional Support</LegalPHeader>
      <LegalP>
        If necessary, you may opt to have a Skyward technical support team assist in consulting for or the development of a custom integration. This additional
        service is charged at $195 per hour.
      </LegalP>
      <LegalPHeader>NDA and Payment</LegalPHeader>
      <LegalP>
        Your firm will need to sign an NDA (Non-Disclosure Agreement) prior to accessing any sandbox or technical information that will be shared.
      </LegalP>
      <LegalP>The scope section of the NDA will be developed between Skyward and your company.</LegalP>
      <LegalP>
        Please review the NDA content to verify that the language will be agreeable before your company sends the signed NDA and PO (if applicable) to Skyward.
      </LegalP>
      <LegalP>
        You can access the Skyward NDA from the following link:
        <br />
        <a href={ndaUrl} target="_blank" rel="noreferrer noopener">
          One Way NDA
        </a>
      </LegalP>
    </>
  );
}

export default SandboxRequestText;
